import type { FaireProductEntity } from "../../entity_types/product";

export const p_vt4hzjrtgz: FaireProductEntity = {
  token: "p_vt4hzjrtgz",
  type: "product",
  name: "Orange Blossom Candle",
  brandToken: "b_fyb6rnmnyf",
  brandName: "Putnam Design LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/f92acb485bae8cfb84d5e45724a5673824618949f28ddc0aaea25e4dcea64c96.jpeg",
  galleryImageUrls: [],
  priceDollars: 20,
  description:
    "Single note scented candle hand-poured and crafted in Los Angeles exclusively by Putnam Design.\n\n• 9 oz of Soy wax\n• 40 hour burn time\n• Trim wick before each use",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:03.120Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
